import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { DMI_LOGIN_CLIENT } from './constants';

/**
 * Direct selector to the Mobile state domain
 */
const selectMobileDomain = (state) => state.mobile || initialState;

const selectNestedScreen = (mainScreen) => createSelector(
  selectMobileDomain,
  ({ nestedScreen }) => nestedScreen[mainScreen],
);
/**
 * Default selector used by Mobile
 */
const makeSelectMobile = (prop) => createSelector(
  selectMobileDomain,
  (mobileState) => mobileState[prop],
);

const makeSelectBuildType = () => createSelector(
  makeSelectMobile('isMobile'),
  makeSelectMobile('isNativeMobile'),
  (isMobile, isNativeMobile) => {
    if (!isMobile) return 'web';
    if (isMobile && !isNativeMobile) return 'mobile-web';
    return 'mobile-native';
  },
);

const makeSelectNativeClients = () => createSelector(
  makeSelectMobile('clients'),
  (clients) => {
    const ssoClients = clients.filter(
      ({ clientAuthentication: { grantType } }) => grantType === 'sso_oidc',
    );
    const hasNonSsoClients = ssoClients.length < clients.length;
    if (!hasNonSsoClients) return ssoClients;
    return ssoClients.concat(DMI_LOGIN_CLIENT);
  },
);

export default makeSelectMobile;
export {
  makeSelectBuildType,
  makeSelectNativeClients,
  selectMobileDomain,
  selectNestedScreen,
};
